import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { SetupGuard } from 'src/auth/guard';
// layouts
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const SetupPage = lazy(() => import('src/pages/setup/setup'));

// ----------------------------------------------------------------------

export const setupRoutes = [
  {
    path: 'setup',
    element: (
      <SetupGuard>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </SetupGuard>
    ),
    children: [
      {
        path: 'user',
        element: <SetupPage />,
      },
    ],
  },
];
